module.exports = __webpack_public_path__ + "img/album_trylisten@3x.894b0544.png";